import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Route, Switch, useLocation } from "react-router-dom"
import PrivateRoute from './PrivateRoute';
import Logout, { LogoutPath } from './pages/Logout';
import Home, { HomePath } from './pages/Home';
import './App.css';
import Page from "./components/Page/MainPage";
import ElectricityCosts, {ElectricityCostPath} from './pages/ElectricityCost';
import SavingEstimate, { SavingEstimatePath } from "./pages/SavingsEstimate";
import { authenticationService } from "./services";
import {getFormData, setData, setProducts, resetProducts} from './store/slices/formDataSlice';
import { apiService } from "./services/api.service";
import SiteBuilder, { SiteBuilderPath } from "./pages/SiteBuilder";
import Addons, { AddonsPath } from "./pages/Addons";
import PricingTerm, { PricingTermPath } from "./pages/PricingTerm";

function App() {
  const [ loggedIn, setLoggedIn ] = useState(authenticationService.currentUserValue);
  const dispatch = useDispatch();
  let location = useLocation();
  // var formData = useSelector(getFormData)

  useEffect(() => {
    authenticationService.currentUser.subscribe(x => {
      setLoggedIn(authenticationService.currentUserValue);
    });
  }, [authenticationService.currentUserValue]);

  useEffect(() => {
      console.log('user changed')
      console.log(authenticationService.currentUserValue)
      dispatch(setData({
        prop: 'repName',
        value: authenticationService?.currentUserValue?.name
      }))
  }, [authenticationService.currentUserValue])

  useEffect(() => {
    if (authenticationService.currentUserValue) {
      apiService.getAllProducts().then((resp) => {
        dispatch(setProducts(resp))
      })
    } else {
      dispatch(resetProducts())
    }

  }, [authenticationService.currentUserValue])

  return (
    <>
      <Page>
        <Route exact path={HomePath} component={Home} />
        <Route path={LogoutPath} component={Logout} />
        <PrivateRoute path={ElectricityCostPath} component={ElectricityCosts} />
        <PrivateRoute path={SavingEstimatePath} component={SavingEstimate} />
        <PrivateRoute path={SiteBuilderPath} component={SiteBuilder} />
        <PrivateRoute path={AddonsPath} component={Addons} />
        <PrivateRoute path={PricingTermPath} component={PricingTerm} />
        {/* <PrivateRoute path={CallAttemptsPath} component={CallAttemptsPage} />

        <PrivateRoute path={CampaignPath} component={Campaigns} />
        <PrivateRoute path={CampaignUserPath} component={CampaignUsers} />
        <PrivateRoute path={ReadyToDialPath} component={ReadyToDial} />
        <PrivateRoute path={CallLogsPath} component={CallLogs} />
        <PrivateRoute path={CallQueuePath} component={CallQueue} />
        <PrivateRoute path={DuplicatePath} component={Duplicates} /> */}
          {/* <Switch>
            <PrivateRoute exact path={CalendarPath + "/:calendar"} component={Calendar} />
          </Switch>
          <Switch>
            <PrivateRoute path={CalendarPath + "/:calendar/:startDate"} component={Calendar} />
          </Switch> */}
      </Page>
    </>
  );
}

export default App;
